import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'SPLIT',
  category: FunctionCategory.TEXT,
  description:
    'Splits each value in a column or a single string into a list. Strings are split on each occurrence of the delimiter.',
  shortDescription: 'Splits strings by a delimiter',
  params: [
    {
      name: 'value',
      type: ArgType.text,
      description: 'Either a column or string.',
    },
    {
      name: 'delimiter',
      type: ArgType.text,
      description: 'Either a column or string to be used as the delimiter to split on.',
    },
  ],
} satisfies AnalysisFunction;
